import { isLATAM } from 'src/utils/localeUtils'
import {
  selectLanguageUS,
  selectLanguageCA,
  selectLanguageLATAM,
  selectLanguageEnglishOnly,
  selectLanguageFrenchOnly,
  selectAllLanguages,
} from './fixture'

/**
 * Returns the appropriate language dropdown options based on the home country
 * @param {string} homeCountry - The user's home country code
 * @returns {Array} Array of language options for the dropdown
 */
function getLanguageDropdownBasedOnCountry(homeCountry) {
  let selectLanguage = []
  switch (homeCountry) {
    case 'US':
      selectLanguage = selectLanguageUS
      break
    case 'CA':
      selectLanguage = selectLanguageCA
      break
    case 'AU':
    case 'NZ':
      selectLanguage = selectLanguageEnglishOnly
      break
    case 'PF':
    case 'NC':
      selectLanguage = selectLanguageFrenchOnly
      break
    default:
      if (isLATAM()) {
        selectLanguage = selectLanguageLATAM
      } else {
        selectLanguage = selectAllLanguages
      }
      break
  }
  return selectLanguage
}

export { getLanguageDropdownBasedOnCountry }
